<template>
  <div class="d-flex flex-column justify-content-around">

    <template v-if="nodeInfo && nodeInfo.cmd === 'batch-alarm-attention'">
      Las alarmas deberán cumplir todos los filtros seleccionados para ser atendidas.
    </template>

    <p v-if="showAlarmCompatibilityMessage" class="text-warning mb-2">
      {{ $t("commands.messages.alarm_category_requires_alarm_compatibility") }}
    </p>

    <validation-observer ref="observer" tag="form">
      <div
        class="field mb-1 w-100"
        v-for="(field, index) in visibleRequirements"
        :key="index"
      >
        <units-select
          v-if="field.type === 'units'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
          :node-config="field"
        ></units-select>
        <alarm-types-select
          v-if="field.type === 'alarm_types'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
          :node-config="field"
        ></alarm-types-select>
        <alarm-levels-select
          v-if="field.type === 'alarm_levels'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
          :node-config="field"
        ></alarm-levels-select>
        <alarm-status-select
          v-if="field.type === 'alarm_status'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
          :node-config="field"
        ></alarm-status-select>
        <alarm-panels-select
          v-else-if="field.type === 'alarm_panel_id'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
          :node-config="field"
        >
        </alarm-panels-select>
        <alarm-panel-devices-select
          v-else-if="field.type === 'alarm_panel_device_id'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
          :node-config="field">
        </alarm-panel-devices-select>
        <cameras-select
          v-else-if="field.type === 'cameras'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></cameras-select>
        <camera-ptz-presets-select
          v-else-if="field.type === 'camera_ptz_presets'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)">
        </camera-ptz-presets-select>
        <device-tags-select
          v-else-if="field.type === 'device_tags'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></device-tags-select>
        <user-views-select
          v-else-if="field.type === 'user_views'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></user-views-select>
        <users-select
          v-else-if="field.type === 'users' || field.type === 'user'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></users-select>
        <profiles-select
          v-else-if="field.type === 'profiles'"
          :multiple="field.multiple || field.multiple === 1"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[profilesStorageKey(field)]"
          :config="resolveConfig(field)"
        ></profiles-select>
        <groups-select
          v-else-if="field.type === 'groups'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></groups-select>
        <helpdesk-groups-select
          v-else-if="field.type === 'helpdesk_groups'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></helpdesk-groups-select>
        <interphones-select
          v-else-if="['interphone_from', 'interphone_to'].includes(field.type)"
          :type="field.type"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></interphones-select>
        <do-select
          v-else-if="field.type == 'do'"
          :type="field.type"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></do-select>
        <message-template-select
          v-else-if="['subject', 'message_template', 'message'].includes(field.type)"
          :type="field.type"
          :multiple="false"
          :multiline="usesMultilineTemplate(field)"
          :rows="usesMultilineTemplate(field) ? 4 : 2"
          :max-chars="field.type === 'subject' ? 255 : 989"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></message-template-select>
        <density-devices-select
          v-else-if="field.type === 'density_device'"
          :multiple="(field.multiple || field.multiple === 1)"
          :type="field.type"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></density-devices-select>
        <type-notification-select
          v-else-if="field.type === 'type'"
          :multiple="(field.multiple || field.multiple === 1)"
          :type="field.type"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></type-notification-select>
        <type-webhook-verb-select
          v-else-if="field.type === 'verb' && model.type == 'webhook'"
          :multiple="(field.multiple || field.multiple === 1)"
          :type="field.type"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></type-webhook-verb-select>
        <action-plan-select
          v-else-if="field.type === 'action_plan'"
          :multiple="(field.multiple || field.multiple === 1)"
          :type="field.type"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></action-plan-select>
        <operational-form-template-select
          v-else-if="field.type === 'operational_form_template'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        />
        <alarm-select
          v-else-if="field.type === 'alarm'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        />
        <alarm-category-message-select
          v-else-if="field.type === 'alarm_category_message'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :config="resolveConfig(field)"
        />
        <layout-select
          v-else-if="field.type === 'layout'"
          :multiple="(field.multiple || field.multiple === 1)"
          :type="field.type"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></layout-select>
        <location-field
          v-else-if="field.type === 'location'"
          :multiple="(field.multiple || field.multiple === 1)"
          :type="field.type"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        />
        <cmd-config-field
          v-else-if="field.type === 'cmd_config'"
          :multiple="false"
          :type="field.type"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :node-info="nodeInfo"
          :context="context"
          :config="resolveConfig(field)"
        />
        <device-proxy-id-field
          v-else-if="field.type === 'device_proxy_id'"
          :multiple="false"
          :type="field.type"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :node-info="nodeInfo"
          :context="context"
          :config="resolveConfig(field)"
        />
        <input-field
          v-else-if="isInputField(field)"
          :multiple="false"
          :type="field.type"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name]"
          :node-info="nodeInfo"
          :context="context"
          :config="resolveConfig(field)"
        />
        <comment-field
          v-else-if="field.type === 'comment'"
          v-model="model[field.name || field.type]"
          :config="resolveConfig(field)"
          :context="context"
        />
        <hidden-field
          v-else-if="field.type === 'hidden'"
          :multiple="false"
          :type="field.type"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :node-info="nodeInfo"
          :context="context"
          :config="resolveConfig(field)"
        />
        <template v-else-if="fields[field.type] && fields[field.type].is_generic">
          <generic-field
            v-if="field.type === 'authorization' && model.type == 'webhook'"
            :multiple="(field.multiple || field.multiple === 1)"
            :type="field.type"
            append-to-body
            :calculate-position="withPopper"
            v-model="model[field.name || field.type]"
            :config="{ ...resolveConfig(field), rules: '' }"
            :context="context"
          ></generic-field>
          <generic-field
            v-if="!['authorization'].includes(field.type)"
            :multiple="(field.multiple || field.multiple === 1)"
            :type="field.type"
            append-to-body
            :calculate-position="withPopper"
            v-model="model[field.name || field.type]"
            :config="resolveConfig(field)"
            :context="context"
          ></generic-field>
        </template>
        <user-panel-select
          v-else-if="field.type === 'user_panel'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        />
        <device-panel
          v-if="field.type === 'device_panel'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        />
        <action-panel
          v-if="field.type === 'action_panel'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        />
        <panel-device-action
          v-if="field.type === 'input' && ['panel_action', 'panel_device_action'].includes(field.subtype)"
          :type="field.type"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        />
        <tenants-select
          v-else-if="field.type === 'tenants'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></tenants-select>
        <centers-select
          v-else-if="field.type === 'centers'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></centers-select>
        <sectors-select
          v-else-if="field.type === 'sectors'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></sectors-select>
        <filter-field
          v-else-if="field.type === 'filter'"
          :multiple="(field.multiple || field.multiple === 1)"
          append-to-body
          :calculate-position="withPopper"
          v-model="model[field.name || field.type]"
          :context="context"
          :config="resolveConfig(field)"
        ></filter-field>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import {ValidationObserver} from "vee-validate";
import UnitsSelect from "./UnitsSelect";
import CamerasSelect from "./CamerasSelect";
import UserViewsSelect from "./UserViewsSelect";
import GenericField from "./GenericField";
import UsersSelect from "./UsersSelect.vue";
import ProfilesSelect from "./ProfilesSelect.vue";
import InterphonesSelect from "./InterphonesSelect.vue";
import DoSelect from "./DoSelect.vue";
import MessageTemplateSelect from "./MessageTemplateSelect.vue";
import PhoneField from "./PhoneField.vue";
import DensityDevicesSelect from "./DensityDevicesSelect.vue";
import TypeNotificationSelect from "./TypeNotificationSelect.vue";
import TypeWebhookVerbSelect from "./TypeWebhookVerbSelect.vue";
import ActionPlanSelect from "./ActionPlanSelect.vue";
import OperationalFormTemplateSelect from "./OperationalFormTemplateSelect.vue";
import AlarmSelect from "./AlarmSelect.vue";
import AlarmCategoryMessageSelect from "./AlarmCategoryMessageSelect.vue";
import LayoutSelect from "./LayoutSelect.vue";
import LocationField from "./LocationField.vue";
import GroupsSelect from "./GroupsSelect.vue";
import TenantsSelect from "./TenantsSelect.vue";
import CentersSelect from "./CentersSelect.vue";
import SectorsSelect from "./SectorsSelect.vue";
import FilterField from "./FilterField.vue";
import fields from "@/libs/CommandFields/fields";
import { sanitizeCommandFieldRules } from "@/libs/CommandFields/rules";
import AlarmPanelsSelect from "./AlarmPanelsSelect.vue";
import AlarmPanelDevicesSelect from "./AlarmPanelDevicesSelect.vue";
import CmdConfigField from "./CmdConfigField.vue";
import CameraPtzPresetsSelect from "./CameraPtzPresetsSelect.vue";
import DeviceTagsSelect from "./DeviceTagsSelect.vue";
import DeviceProxyIdField from "./DeviceProxyIdField.vue";
import HiddenField from "./HiddenField.vue";
import AlarmTypesSelect from "./AlarmTypesSelect.vue";
import AlarmLevelsSelect from "./AlarmLevelsSelect.vue";
import AlarmStatusSelect from "./AlarmStatusSelect.vue";
import InputField from "./InputField.vue";
import CommentField from "./CommentField.vue";
import HelpdeskGroupsSelect from "./HelpdeskGroupsSelect.vue";
import UserPanelSelect from "./UserPanelSelect.vue";
import DevicePanel from "./DevicePanel.vue";
import ActionPanel from "./ActionPanel.vue";
import PanelDeviceAction from "./PanelDeviceAction.vue";
import popperHelper from "@/libs/popper-helper";
import { isAssignOperationalFormTaskEditorContext } from "@/libs/assignOperationalFormTask";
import {
  isNotificationCommand,
  isNotificationRequirementVisible,
  NOTIFICATION_IN_APP_TYPE,
  NOTIFICATION_RECEIVER_FIELD,
  orderNotificationRequirements,
  usesMultilineNotificationTemplate,
  withNotificationProfilesRequirement,
} from "@/libs/CommandFields/notificationCommand";

export default {
  name: "NodeData",
  components: {
    DeviceTagsSelect,
    CameraPtzPresetsSelect,
    AlarmPanelDevicesSelect,
    ValidationObserver,
    UnitsSelect,
    CamerasSelect,
    UserViewsSelect,
    GenericField,
    UsersSelect,
    ProfilesSelect,
    InterphonesSelect,
    DoSelect,
    MessageTemplateSelect,
    PhoneField,
    DensityDevicesSelect,
    TypeNotificationSelect,
    TypeWebhookVerbSelect,
    ActionPlanSelect,
    OperationalFormTemplateSelect,
    AlarmSelect,
    AlarmCategoryMessageSelect,
    LayoutSelect,
    LocationField,
    GroupsSelect,
    TenantsSelect,
    CentersSelect,
    SectorsSelect,
    FilterField,
    AlarmPanelsSelect,
    CmdConfigField,
    DeviceProxyIdField,
    HiddenField,
    AlarmTypesSelect,
    AlarmLevelsSelect,
    AlarmStatusSelect,
    InputField,
    CommentField,
    HelpdeskGroupsSelect,
    UserPanelSelect,
    DevicePanel,
    ActionPanel,
    PanelDeviceAction,
  },
  props: {
    value: Array | Object,
    nodeInfo: Object,
    requirements: Array,
    flowchartConfig: {
      type: Object,
      default: () => ({alarm_compatible: false}),
    },
  },
  data() {
    return {
      model: {},
      fields,
      withPopper: popperHelper.withPopper,
    };
  },
  created() {
    this.model = this.value || {};

    if (
      this.isNotificationCommand
      && this.model.type === NOTIFICATION_IN_APP_TYPE
      && !this.model[NOTIFICATION_RECEIVER_FIELD]
      && this.model.profiles
    ) {
      this.$set(this.model, NOTIFICATION_RECEIVER_FIELD, this.model.profiles);
    }
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
  },
  computed: {
    isNotificationCommand() {
      return isNotificationCommand(this.nodeInfo);
    },
    isAssignOperationalFormTaskCommand() {
      return isAssignOperationalFormTaskEditorContext(
        this.nodeInfo,
        this.requirements
      );
    },
    showAlarmCompatibilityMessage() {
      return this.nodeInfo?.cmd === "update:alarm_category"
        && !this.flowchartConfig.alarm_compatible;
    },
    visibleRequirements() {
      const list = withNotificationProfilesRequirement(this.requirements, this.nodeInfo);
      const visibleList = this.isAssignOperationalFormTaskCommand
        // `users` is hidden on purpose: the task is always assigned to the
        // operator running the action plan, injected at execution time.
        ? list.filter(
          (field) =>
            field.type === "operational_form_template" || field.type === "input"
        )
        : list;

      const requirements = visibleList.filter((field) =>
        isNotificationRequirementVisible(field, this.nodeInfo, this.model)
      );

      return orderNotificationRequirements(requirements, this.nodeInfo);
    },
    context() {
      return {
        flowchartConfig: this.flowchartConfig,
        model: this.model,
        command: this.nodeInfo?.name,
      };
    },
  },
  methods: {
    profilesStorageKey(field) {
      return this.isNotificationCommand
        ? NOTIFICATION_RECEIVER_FIELD
        : field.name || field.type;
    },
    usesMultilineTemplate(field) {
      return usesMultilineNotificationTemplate(field, this.nodeInfo);
    },
    isInputField(field) {
      const panelSubtypes = ["panel_action", "panel_device_action"];

      const ignoreSubtypes = [
        ...panelSubtypes,
        // in case of more subtypes
      ];

      return field.type === 'input' && !ignoreSubtypes.includes(field.subtype);
    },
    resolveConfig(field) {
      const config = this.buildFieldConfig(field);

      return { ...config, rules: sanitizeCommandFieldRules(config.rules) };
    },
    buildFieldConfig(field) {

      const defaultConfig = this.fields[field.type] || {};

      if (field.version && field.version === 2) {
        const fieldData = Object.fromEntries(
          Object.entries(field).map(([key, value]) =>
            [key, value !== undefined && value !== null && value !== '' ? value : defaultConfig[key]]
          )
        );
        const merged = { ...defaultConfig, ...fieldData };
        if (
          defaultConfig.label &&
          typeof field.label === "string" &&
          field.label.length &&
          !field.label.startsWith("commands.")
        ) {
          merged.label = defaultConfig.label;
        }
        return merged;
      }

      if (
        defaultConfig.label &&
        typeof field.label === "string" &&
        field.label.length &&
        !field.label.startsWith("commands.")
      ) {
        return { ...defaultConfig, label: defaultConfig.label };
      }

      return defaultConfig;
    }
  }
};
</script>

<style></style>
